import EmbroiderRouter from "@embroider/router";

import config from "#config";

import { buildAutoRoutes } from "#utils/auto-routes.ts";

export default class Router extends EmbroiderRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route("play", function () {
    // this.route("index", { path: "/" });
    this.route("error", { path: "/song-error" });
    this.route("song", { path: "/:song_data" });
  });
  buildAutoRoutes(this);
});
